export const Logo = ({ className = "", size = 40 }) => (
  <img
    src="/aurelume-mark.png"
    alt="Aurelume"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "contain" }}
  />
);
